import { Search, Bell, Menu, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface SearchHeaderProps {
  onMenuClick?: () => void;
  isMobile?: boolean;
}

export function SearchHeader({ onMenuClick, isMobile }: SearchHeaderProps) {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:px-6">
        {/* Mobile Menu Button - Only visible on mobile */}
        {isMobile && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onMenuClick}
            className="md:hidden"
            aria-label="Toggle menu"
          >
            <Menu className="h-5 w-5" />
          </Button>
        )}

        {/* Logo - Links to dashboard when logged in */}
        <Link to="/dashboard" className="flex items-center gap-2">
          <BookOpen className="h-6 w-6 text-primary" />
          <span className="text-xl font-semibold text-primary hidden md:inline-block">
            Numberz Insight
          </span>
        </Link>

        {/* Center the search bar on desktop */}
        <div className="flex-1 flex justify-center max-w-3xl mx-auto">
          <div className="relative w-full md:w-[600px]">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input 
              placeholder="Search services, documents, help..." 
              className="w-full pl-9 bg-background pr-4"
            />
          </div>
        </div>

        {/* Actions section */}
        <div className="flex items-center gap-4">
          {/* Theme Toggle - Only visible on desktop */}
          {!isMobile && (
            <div className="hidden md:flex">
              <ThemeToggle />
            </div>
          )}

          {/* Notifications */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="relative">
                <Bell className="h-5 w-5" />
                <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] text-primary-foreground">
                  3
                </span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-80">
              <DropdownMenuItem className="cursor-pointer">
                New message from support
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer">
                Your tax return was processed
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer">
                Document verification required
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}